<div style="height:calc(100vh - 130px); padding-top:35px;">
  <div id='canvas' #canvas>
    <section>
      <ko-stage #stage id="stage" [config]="configStage">
        <!-- ページのグリッドを表示するレイヤー -->
        <ko-layer #layerPage [config]="configLayerPage"></ko-layer>
        <!-- セクションのグリッドを表示するレイヤー -->
        <ko-layer #layerSection [config]="configLayerSection"></ko-layer>
        <!-- セクションプロキシを表示するレイヤー -->
        <ko-layer #layerSectionProxy [config]="configLayerSectionProxy"></ko-layer>
        <!-- セクション枠を表示するレイヤー -->
        <ko-layer #layerSectionFrame [config]="configLayerSectionFrame"></ko-layer>
      </ko-stage>
    </section>
  </div>
</div>
